import { render, staticRenderFns } from "./ApproverManagement.vue?vue&type=template&id=d6e66480&scoped=true"
import script from "./ApproverManagement.vue?vue&type=script&lang=js"
export * from "./ApproverManagement.vue?vue&type=script&lang=js"
import style0 from "./ApproverManagement.vue?vue&type=style&index=0&id=d6e66480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e66480",
  null
  
)

export default component.exports